module.exports = __webpack_public_path__ + "img/Deathknight-orc-m-70.d260c11d.gif";